// splide

document.addEventListener('DOMContentLoaded', function () {
  const splide = new Splide('.splide', {
    type: 'loop',
    fixedWidth: '70rem',
    fixedHeight: '40rem',
    gap: '3.25rem',
    padding: {
      left: 0,
      right: 0
    },
    focus: 1,
    pagination: false,
    breakpoints: {
      990: {
        perPage: 1,
        fixedWidth: '100%',
        fixedHeight: '40rem',
        padding: {
          left: 0,
          right: 0
        }
      },
    }
  });

  splide.on('ready', function () {
    // get the currently selected slide
    const currentSlide = document.querySelector('.splide__slide.is-prev');

    if (currentSlide) {
      const currentRoomHandle = currentSlide.dataset.room;
      const currentTab = document.querySelector(`.shop-the-room--tab[data-room="${currentRoomHandle}"`);

      document.querySelectorAll('.shop-the-room--tab').forEach((tab) => {
        tab.classList.remove('is-current');
      });

      if (currentTab) {
        currentTab.classList.add('is-current');
      }
    }
  });

  splide.on('active', function () {
    // get the currently selected slide
    const currentSlide = document.querySelector('.splide__slide.is-prev');

    if (currentSlide) {
      const currentRoomHandle = currentSlide.dataset.room;
      const currentTab = document.querySelector(`.shop-the-room--tab[data-room="${currentRoomHandle}"`);

      document.querySelectorAll('.shop-the-room--tab').forEach((tab) => {
        tab.classList.remove('is-current');
      });

      if (currentTab) {
        currentTab.classList.add('is-current');
      }
    }
  });

  splide.on('resize', function () {
    if (window.innerWidth >= 1240) {
      const contentMargin = ((window.innerWidth - 1200) / 2);
      const contentWidth = window.innerWidth / 2;
      splide.options = {
        padding: {
          left: contentWidth - 350,
          right: 0
        },
        breakpoints: {
          990: {
            padding: {
              left: 0,
              right: 0
            }
          },
        }
      };

      splide.go(1);
    }
  });

  splide.mount();
});
